module.exports = __webpack_public_path__ + "img/frame (258).883bc5a9.jpg";